import classNames from 'classnames/bind';
import GatsbyImage from 'gatsby-image';
import PropTypes from 'prop-types';
import React from 'react';

import Heading from 'components/shared/heading';

import styles from './slide.module.scss';

const cx = classNames.bind(styles);

const Slide = ({ title, description, appImage, link }) => {
  return (
    <div className={cx('slide')}>
      <Heading className={cx('title')} tag="h3" size="sm" theme="secondary">
        {title}
      </Heading>
      <div className={cx('image-wrapper')}>
        <GatsbyImage fluid={appImage.childImageSharp.fluid} fadeIn={false} />
      </div>
      <div className={cx('info')}>
        <p className={cx('description')}>{description}</p>
        <a
          className={cx('link', `link-${title.toLowerCase()}`)}
          href={link}
          target="_blank"
          rel="noreferrer"
        >
          {link.replace('https://', '')}
        </a>
      </div>
    </div>
  );
};

export default Slide;

Slide.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  appImage: PropTypes.object.isRequired,
};
